import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GeckoBtn } from 'ui';
import GeckoDate from 'services/gecko-date';

import './index.scss';

class BotTabEditContainer extends Component {
  static propTypes = {
    title: PropTypes.string,
    updated: PropTypes.string,
    cancelText: PropTypes.string,
    cancelIcon: PropTypes.string,
    onCancel: PropTypes.func,
    cloneText: PropTypes.string,
    cloneIcon: PropTypes.string,
    onClone: PropTypes.func,
    saveText: PropTypes.string,
    saveIcon: PropTypes.string,
    onSave: PropTypes.func,
    deleteText: PropTypes.string,
    deleteIcon: PropTypes.string,
    onDelete: PropTypes.func,
    children: PropTypes.element,
  };

  static defaultProps = {
    updated: {},
    cancelText: 'Cancel\u2060',
    cancelIcon: 'far fa-times',
    onCancel: () => {},
    cloneText: 'Clone\u2060',
    cloneIcon: 'far fa-copy',
    saveText: 'Save Settings',
    saveIcon: 'far fa-save',
    onSave: () => {},
    deleteText: 'Delete',
    deleteIcon: 'far fa-trash-alt',
  };

  constructor(props) {
    super(props);
    this.state = {
      cancelling: false,
      saving: false,
    };
  }

  handleCancel() {
    this.setState({ cancelling: true });
    return Promise.resolve(this.props.onCancel())
      .then(() => this.setState({ cancelling: false }))
      .catch(() => this.setState({ cancelling: false }));
  }

  handleClone() {
    this.setState({ cloning: true });
    return Promise.resolve(this.props.onClone())
      .then(() => this.setState({ cloning: false }))
      .catch(() => this.setState({ cloning: false }));
  }

  handleSave() {
    this.setState({ saving: true });
    return Promise.resolve(this.props.onSave())
      .then(() => this.setState({ saving: false }))
      .catch(() => this.setState({ saving: false }));
  }

  handleDelete() {
    this.setState({ cancelling: true });
    return Promise.resolve(this.props.onDelete())
      .then(() => this.setState({ cancelling: false }))
      .catch(() => this.setState({ cancelling: false }));
  }

  render() {
    return (
      <div className="BotTabEditContainer card gecko-card">
        <div className="BotTabEditContainer-header-container gecko-card-header">
          <div className="BotTabEditContainer-title">
            <h2 className="header-title">{this.props.title}</h2>
            {this.props.updated?.at && (
              <p className="updated-details">
                {`Last edited${
                  this.props.updated.by
                    ? ` by ${this.props.updated.by.first_name} ${this.props.updated.by.last_name}`
                    : ''
                } on ${new GeckoDate(this.props.updated.at).LONG_TIME}`}
              </p>
            )}
          </div>
          <div className="header-container gecko-btns clearfix">
            <GeckoBtn
              name={this.props.cancelText}
              handler={this.handleCancel.bind(this)}
              disabledWhen={() => this.state.saving || this.state.cancelling}
              icon={
                this.state.cancelling
                  ? 'far fa-spinner-third fa-spin'
                  : this.props.cancelIcon
              }
            />
            <GeckoBtn
              name={this.props.saveText}
              handler={this.handleSave.bind(this)}
              disabledWhen={() =>
                this.state.saving ||
                this.state.cancelling ||
                this.props.disableSave
              }
              icon={
                this.state.saving
                  ? 'far fa-spinner-third fa-spin'
                  : this.props.saveIcon
              }
              preset="save"
            />
          </div>
        </div>
        <div className="BotsTabEditContainer-form gecko-card-body padded">
          <div className="row">{this.props.children}</div>
        </div>
        <div className="BotTabEditContainer-footer-container footer">
          {this.props.onDelete ? (
            <GeckoBtn
              name={this.props.deleteText}
              handler={this.handleDelete.bind(this)}
              disabledWhen={() => this.state.saving || this.state.cancelling}
              icon={
                this.state.cancelling
                  ? 'far fa-spinner-third fa-spin'
                  : this.props.deleteIcon
              }
              className="BotTabEditContainer-delete-button"
              type="danger"
            />
          ) : null}
          {this.props.onClone ? (
            <GeckoBtn
              name={this.props.cloneText}
              handler={this.handleClone.bind(this)}
              disabledWhen={() => this.state.cloning || this.state.saving}
              icon={
                this.state.cloning
                  ? 'far fa-spinner-third fa-spin'
                  : this.props.cloneIcon
              }
            />
          ) : null}

          <div className="BotTabEditContainer-spacer"></div>

          <div class="gecko-btns">
            <GeckoBtn
              name={this.props.cancelText}
              handler={this.handleCancel.bind(this)}
              disabledWhen={() => this.state.saving || this.state.cancelling}
              icon={
                this.state.cancelling
                  ? 'far fa-spinner-third fa-spin'
                  : this.props.cancelIcon
              }
            />
            <GeckoBtn
              name={this.props.saveText}
              handler={this.handleSave.bind(this)}
              disabledWhen={() =>
                this.state.saving ||
                this.state.cancelling ||
                this.props.disableSave
              }
              icon={
                this.state.saving
                  ? 'far fa-spinner-third fa-spin'
                  : this.props.saveIcon
              }
              preset="save"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default BotTabEditContainer;
